<template>
  <v-container>

    <!-- error -->
    <v-row v-if="error">
      <v-col cols="12" sm="6">
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-col>
    </v-row>

    <v-card flat>
      <v-card-title class="mb-n6">
        Get Started
      </v-card-title>

      <v-card-text>
        <form @submit.prevent="onSignup">
          <v-row>
            <v-col cols="12">
              <v-text-field name="username" label="Username" id="username" v-model="username" required>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-text-field name="email" label="Email" id="email" type="email" v-model="email" required>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-text-field name="password" label="Password" id="password" type="password" v-model="password" required>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-text-field name="confirmPassword" label="Confirm Password" id="confirmPassword"
              v-model="confirmPassword" type="password" required :rules="[comparePasswords]">
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn type="submit" block depressed color="grey darken-4" dark class="ma-2"

            :disabled="loading" :loading="loading">
            Sign Up
            <span slot="loader" class="custom-loader">
              <v-icon light>cached</v-icon>
            </span>    </v-btn>
          </v-col>
        </v-row>

      </form>
    </v-card-text>
  </v-card>


</v-container>
</template>

<script>
export default {
  data: ()=> ({
    username:'',
    name:'',
    email:'',
    password: '',
    confirmPassword:'',

  }),
  computed:{
    comparePasswords(){
      return this.password !== this.confirmPassword ? 'Passwords Do Not Match' : ''
    },
    user(){
      return this.$store.getters.user
    },
    error(){
      return this.$store.getters.error
    },
    loading(){
      return this.$store.getters.loading
    }
  },
  watch:{
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
    user(value){
      if(value !== null && value !== undefined){
        this.$router.push('/')
      }
    }
  },
  methods: {
    onSignup(){
      //vuex
      const newUser={
        username:this.username,
        name:this.name,
        email:this.email,
        password: this.password,
      }
      this.$store.dispatch('registerUser', newUser)
    },
    onDismissed(){
      this.$store.dispatch('clearError')
    }
  }
}
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}


</style>
